import { useState, useEffect } from 'react';
import { sendApiRequest } from '../../api/request';
import EditingPanel from './EditingPanel';

export default function Services() {
  const [action, setAction] = useState('create');
  const [packId, setPackId] = useState('');
  const [servicePacks, setServicePacks] = useState([]);
  const [id, setId] = useState('');
  const [language, setLanguage] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [price, setPrice] = useState('');
  const [message, setMessage] = useState('');

  // Fetch all service packs on mount
  useEffect(() => {
    const fetchPacks = async () => {
      try {
        const packs = await sendApiRequest('GET', '/admin/services/packs');
        setServicePacks(packs);
      } catch (err) {
        console.error('Failed to fetch service packs', err);
      }
    };
    fetchPacks();
  }, []);

  const handleSubmit = async () => {
    setMessage('');
    if (!packId) {
      setMessage('Please select a service pack.');
      return;
    }

    try {
      if (action === 'create') {
        if (!id || !language || !name) {
          setMessage('Please fill in ID, language, and name.');
          return;
        }

        const serviceData = {
          serviceId: { id: Number(id), language },
          name,
          description,
          imageUrl,
          price,
        };

        const updatedPack = await sendApiRequest('POST', `/admin/services/packs/${packId}/services`, serviceData);
        setMessage(`Service added to pack ${updatedPack?.name ?? packId}`);
      } else if (action === 'delete') {
        if (!id || !language) {
          setMessage('Please provide both ID and language to delete a service.');
          return;
        }

        await sendApiRequest('DELETE', `/admin/services/packs/${packId}/services/${id}/${language}`);
        setMessage(`Service ${id} (${language}) removed from pack ${packId}.`);
      }

      setId('');
      setLanguage('');
      setName('');
      setDescription('');
      setImageUrl('');
      setPrice('');
    } catch (error) {
      setMessage(error?.message ?? 'Request failed');
    }
  };

  return (
    <EditingPanel
      title={action === 'create' ? 'Add / Update Service' : 'Delete Service'}
      action={action}
      onActionChange={setAction}
      actions={[
        { value: 'create', label: 'Add / Update' },
        { value: 'delete', label: 'Delete' },
      ]}
      topRow={
        <>
          <div className="editing-panel__field">
            <label>Service Pack</label>
            <select value={packId} onChange={(e) => setPackId(e.target.value)}>
              <option value="">Select a pack</option>
              {servicePacks.map((pack) => (
                <option key={pack.id} value={pack.id}>
                  {pack.name} (ID {pack.id})
                </option>
              ))}
            </select>
          </div>

          <div className="editing-panel__field">
            <label>Service ID</label>
            <input
              type="number"
              value={id}
              onChange={(e) => setId(e.target.value)}
              placeholder="Enter service ID"
            />
          </div>

          <div className="editing-panel__field">
            <label>Language</label>
            <input
              type="text"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              placeholder="e.g. en or no"
            />
          </div>
        </>
      }
      grid={
        action === 'create' && (
          <>
            <div className="editing-panel__field">
              <label>Service Name</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter service name"
              />
            </div>

            <div className="editing-panel__field editing-panel__field--span-2">
              <label>Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter service description"
              />
            </div>

            <div className="editing-panel__field">
              <label>Image URL</label>
              <input
                type="text"
                value={imageUrl}
                onChange={(e) => setImageUrl(e.target.value)}
                placeholder="e.g. uploads/service.jpg"
              />
            </div>

            <div className="editing-panel__field editing-panel__field--span-2">
              <label>Price</label>
              <textarea
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="e.g. 150 NOK"
              />
            </div>
          </>
        )
      }
      onSubmit={handleSubmit}
      isDanger={action === 'delete'}
      submitLabel={action === 'delete' ? 'Delete Service' : 'Save Service'}
      message={message}
    />
  );
}
